export default __webpack_public_path__ + "static/intro-66984d54636d6dfd865ae3b84c500dc7.webm";